import {Locale, THrefLangByLocale} from './locale';

export const getHrefLangRelatedToLocale = (
  locale: Locale,
): THrefLangByLocale[] => {
  switch (locale) {
    case 'de_DE':
    case 'de_AT':
    case 'de_CH':
      return [
        {
          locale: Locale.de_DE,
          hrefLang: 'de-DE',
        },
        {
          locale: Locale.de_AT,
          hrefLang: 'de-AT',
        },
        {
          locale: Locale.de_CH,
          hrefLang: 'de-CH',
        },
      ];
    case 'fr_CH':
    case 'fr_BE':
    case 'fr_FR':
    case 'fr_LU':
      return [
        {
          locale: Locale.fr_CH,
          hrefLang: 'fr-CH',
        },
        {
          locale: Locale.fr_BE,
          hrefLang: 'fr-BE',
        },
        {
          locale: Locale.fr_FR,
          hrefLang: 'fr-FR',
        },
        {
          locale: Locale.fr_LU,
          hrefLang: 'fr-LU',
        },
      ];
    case 'nl_NL':
    case 'nl_BE':
      return [
        {
          locale: Locale.nl_NL,
          hrefLang: 'nl-NL',
        },
        {
          locale: Locale.nl_BE,
          hrefLang: 'nl-BE',
        },
      ];
    case 'cs_CZ':
    case 'sk_SK':
    case 'pl_PL':
      return [
        {
          locale: Locale.cs_CZ,
          hrefLang: 'cs-CZ',
        },
        {
          locale: Locale.sk_SK,
          hrefLang: 'sk-SK',
        },
        {
          locale: Locale.pl_PL,
          hrefLang: 'pl-PL',
        },
      ];
    case 'lt_LT':
    case 'lv_LV':
      return [
        {
          locale: Locale.lt_LT,
          hrefLang: 'lt-LT',
        },
        {
          locale: Locale.lv_LV,
          hrefLang: 'lv-LV',
        },
      ];
    case 'es_ES':
    case 'it_IT':
    case 'pt_PT':
      return [
        {
          locale: Locale.es_ES,
          hrefLang: 'es-ES',
        },
        {
          locale: Locale.it_IT,
          hrefLang: 'it-IT',
        },
        {
          locale: Locale.pt_PT,
          hrefLang: 'pt-PT',
        },
      ];
    case 'da_DK':
    case 'sv_SE':
      return [
        {
          locale: Locale.da_DK,
          hrefLang: 'da-DK',
        },
        {
          locale: Locale.sv_SE,
          hrefLang: 'sv-SE',
        },
      ];
    case 'sl_SI':
    case 'hr_HR':
      return [
        {
          locale: Locale.sl_SI,
          hrefLang: 'sl-SI',
        },
        {
          locale: Locale.hr_HR,
          hrefLang: 'hr-HR',
        },
      ];
    default:
      return [];
  }
};
